import BemIt, { addClass } from "@gtechdoodler/bem-it";
import { StyledTableRow } from "./TableRow.styles";
import { TableRowProps } from "./TableRow.types";

const TableRow: React.FC<TableRowProps> = ({
	children,
	variant = "default",
	className,
	...props
}) => {
	const block = new BemIt("TableRow");

	return (
		<StyledTableRow
			className={addClass(className).after(block)}
			{...props}
			variant={variant}
		>
			{children}
		</StyledTableRow>
	);
};

export default TableRow;
